__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "src-rx";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@iobroker/adapter-react-v5", "4.13.23", () => (Promise.all([__webpack_require__.e(6416), __webpack_require__.e(212), __webpack_require__.e(591), __webpack_require__.e(4798), __webpack_require__.e(3100), __webpack_require__.e(9183), __webpack_require__.e(1999), __webpack_require__.e(2619), __webpack_require__.e(8030), __webpack_require__.e(4040)]).then(() => (() => (__webpack_require__(6025))))));
			register("@mui/icons-material", "5.15.18", () => (Promise.all([__webpack_require__.e(8795), __webpack_require__.e(6416), __webpack_require__.e(9183), __webpack_require__.e(1999)]).then(() => (() => (__webpack_require__(88795))))));
			register("@mui/material", "5.14.14", () => (Promise.all([__webpack_require__.e(6416), __webpack_require__.e(212), __webpack_require__.e(591), __webpack_require__.e(2181), __webpack_require__.e(2954), __webpack_require__.e(9183), __webpack_require__.e(1999), __webpack_require__.e(2619)]).then(() => (() => (__webpack_require__(92954))))));
			register("@mui/styles", "5.14.14", () => (Promise.all([__webpack_require__.e(9404), __webpack_require__.e(9183), __webpack_require__.e(1999), __webpack_require__.e(2058)]).then(() => (() => (__webpack_require__(99404))))));
			register("prop-types", "15.8.1", () => (__webpack_require__.e(5259).then(() => (() => (__webpack_require__(15259))))));
			register("react-ace", "11.0.1", () => (Promise.all([__webpack_require__.e(6321), __webpack_require__.e(1407), __webpack_require__.e(9183), __webpack_require__.e(1999)]).then(() => (() => (__webpack_require__(73788))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(5096), __webpack_require__.e(9183)]).then(() => (() => (__webpack_require__(25096))))));
			register("react", "18.3.1", () => (__webpack_require__.e(4905).then(() => (() => (__webpack_require__(34905))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};